<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="developer-screen">
    <h3 class="heading">{{ 'developer.just-getting-started' | translate }}</h3>

    <div class="developer-card">
      <div class="inner-card">

        <img src="../../../../assets/images/dev.png" class="dev" alt="">
        <h2>{{ 'developer.not-a-developer' | translate }}</h2>
        <p>
          {{ 'developer.use-prefix' | translate }} <a href="javascript:void(0)">{{ 'developer.api-keys-title' | translate }}</a> {{ 'developer.download-resources' | translate }}
        </p>

        <!-- Client Name -->
        <div class="form-group">
          <label class="form-label">{{ "developer.apiKeySectionTitle1" | translate }}</label>
          <input type="text" class="form-control" [placeholder]="'developer.enter-client-name' | translate" [(ngModel)]="clientName"
            [disabled]="isDisabled" />
        </div>

        <!-- API Key Management -->
        <div class="form-group">
          <label class="form-label">{{ "developer.apiKeySectionTitle2" | translate }}</label>

          <div class="api-key">
            <input type="text" class="form-control" [value]="apiKey" readonly #apiKeyInput
              placeholder="{{ 'developer.apiKeyPlaceholder' | translate }}" />

            <button class="btn btn-copy" type="button" (click)="copyApiKey(apiKeyInput)">
              {{ (copied ? "developer.copied" : "developer.copy") | translate }}
            </button>
          </div>
        </div>

        <!-- Generate Button -->
        <button class="btn btn-primary btn-sm width-fit" [disabled]="!clientName" (click)="generateApiKey(clientName)">
          {{ isApiKey ? ('developer.regenerate-api-key' | translate) : ('developer.generate-api-key' | translate) }}
        </button>
      </div>

      <!-- RIGHT SIDE CARD -->
      <div class="inner-card">
        <div class="client-libraries-card">

          <h3>{{ 'developer.client-libraries' | translate }}</h3>
          <p>{{ "developer.downloadsDescription" | translate }}</p>

          <div class="libraries">
            <div class="library">
              <img src="../../../../assets/images/lib1.png" alt="">
              <span>Ruby</span>
            </div>
            <div class="library">
              <img src="../../../../assets/images/lib2.png" alt="">
              <span>Java</span>
            </div>
            <div class="library">
              <img src="../../../../assets/images/lib3.png" alt="">
              <span>Node.Js</span>
            </div>
            <div class="library">
              <img src="../../../../assets/images/lib4.png" alt="">
              <span>Python</span>
            </div>
          </div>

          <div class="bottom">
            <button class="btn btn-primary-outline btn-sm w-100" (click)="downloadDummyPdf()">
              {{ "developer.downloadPdfButton" | translate }}
            </button>

            <button class="btn btn-primary btn-sm w-100" (click)="downloadCollection()">
              {{ "developer.downloadCollectionButton" | translate }}
            </button>
          </div>

        </div>
      </div>
    </div>

    <div class="authentication-guide-card">
      <h3>
        {{ 'developer.auth-guide' | translate }}
      </h3>
      <div class="guide-card">
        <div class="gc-header">
          <span>{{ 'developer.endpoint' | translate }}</span>
        </div>
        <div class="gc-body">
          <div class="code">
            https://xi5f-5y62-kbyr.n7e.xano.io/api:BB6HooOR/luqtaWebhook
          </div>
          <h4>
            {{ 'developer.authorization' | translate }}
          </h4>
          <p>
            {{ 'developer.auth-usage' | translate }}
          </p>
        </div>
      </div>
      <div class="guide-card">
        <div class="gc-header">
          <span>{{ 'developer.example-curl' | translate }}</span>
        </div>
        <div class="gc-body">
          <div class="code">
            curl -G "https://xi5f-5y62-kbyr.n7e.xano.io/api:BB6HooOR/luqtaWebhook"\
            <br>
            --data-urlencode "apiKey=YOUR_KEY"
          </div>
          <h4>
            {{ 'developer.response-json-list' | translate }}
          </h4>
        </div>
      </div>
      <div class="guide-card">
        <div class="gc-header">
          <span>{{ 'developer.key-points' | translate }}</span>
        </div>
        <div class="gc-body">
          <ul>
            <li>
              <span>
                <b>APIkey</b> {{ 'developer.apikey-required-suffix' | translate }}
              </span>
            </li>
            <li>
              <span>
                {{ 'developer.apikey-error-handling-prefix' | translate }} <b>apikey</b> {{ 'developer.apikey-invalid-suffix' | translate }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
